import { render, staticRenderFns } from "./ComponentCommunicationDetail.vue?vue&type=template&id=7beca7ea&"
import script from "./ComponentCommunicationDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentCommunicationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports